import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as styles from './TwitterPreview.scss';
var TwitterPreview = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(TwitterPreview, _Component);

  var _super = _createSuper(TwitterPreview);

  function TwitterPreview() {
    _classCallCheck(this, TwitterPreview);

    return _super.apply(this, arguments);
  }

  _createClass(TwitterPreview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          quote = _this$props.quote,
          images = _this$props.images,
          handle = _this$props.handle,
          message = _this$props.message,
          likes = _this$props.likes,
          postTime = _this$props.postTime,
          profileImage = _this$props.profileImage,
          reTweets = _this$props.reTweets,
          username = _this$props.username,
          videos = _this$props.videos;
      var imageLink = null;
      var videoLink = null;

      if (images && images.length > 0) {
        imageLink = images[0].media_url_https;
      }

      if (videos && videos.length > 0) {
        imageLink = null;
        videoLink = this.props.videos[0];
      }

      return /*#__PURE__*/React.createElement("div", {
        className: styles.twitter_preview
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.profileWrap
      }, /*#__PURE__*/React.createElement("img", {
        src: profileImage,
        className: styles.profileImg
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.profileNameWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.profileName
      }, username), /*#__PURE__*/React.createElement("span", {
        className: styles.profileHandle
      }, handle))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: styles.post
      }, " ", message), imageLink && /*#__PURE__*/React.createElement("div", {
        className: styles.postImgWrap
      }, /*#__PURE__*/React.createElement("img", {
        className: styles.postImg,
        src: imageLink
      })), quote && /*#__PURE__*/React.createElement("div", {
        className: styles.quoteWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.profileRow
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.profileRowText
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: styles.quoteUsername
      }, quote.username), /*#__PURE__*/React.createElement("span", {
        className: styles.quoteHandle
      }, " @", quote.handle, " ")), /*#__PURE__*/React.createElement("div", {
        className: styles.quoteParentHandle
      }, "Replying to @", quote.replyToHandle), /*#__PURE__*/React.createElement("div", {
        className: styles.quoteText
      }, quote.text))))), /*#__PURE__*/React.createElement("div", {
        className: styles.belowPostWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.datetime
      }, " ", postTime, " ")));
    }
  }]);

  return TwitterPreview;
}(Component), _defineProperty(_class2, "defaultProps", {
  image: false,
  message: 'Likeable Local - Social media automated for your business',
  quote: null,
  likes: 125,
  reTweets: 523,
  postTime: '1:31 PM - 9 Jun 2017',
  profileImage: 'http://bit.ly/2tKR30T',
  username: 'Likeable Local',
  handle: '@likeablelocal',
  videos: []
}), _temp)) || _class);
export default TwitterPreview;